'use client';
import type { FC } from 'react';
import { useMemo, useRef, useState } from 'react';

import debounce from 'lodash.debounce';

import { Checkbox } from '@wwe-portal/ui/components/checkbox';

interface EmailSubscribeFormProps {
  action: string;
}
export const EmailSubscribeForm: FC<EmailSubscribeFormProps> = ({ action }) => {
  const emailRef = useRef<HTMLInputElement>(null);
  const [email, setEmail] = useState('');
  const [checked, setChecked] = useState(false);

  const debounceChangeEmail = useMemo(
    () =>
      debounce((nextEmail: string) => {
        setEmail(nextEmail);
      }, 300),
    []
  );

  const handleSubmit = () => {
    if (emailRef.current) {
      emailRef.current.value = '';
    }
    setChecked(false);
  };

  const submitDisabled = !checked || !email;

  return (
    <form
      action={action}
      className="validate"
      method="post"
      onSubmit={handleSubmit}
      target="_blank"
    >
      <div className="text-text700 mt-4 flex flex-col gap-3 text-sm">
        <div>
          JOIN OUR MAILING LIST!
          <br /> Sign up for special updates on events, deals, and more!
        </div>
        <div className="pb-2">
          <input
            autoComplete="off"
            className="text-text700 focus:text-text500 bg-back300 border-back300 hover:border-text700 focus:border-text700 visible-focus:outline-none placeholder-text700 focus:bg-back400 h-[calc(1.5em_+_1rem_+_2px)] w-full rounded-md border px-8 py-2 focus:outline-none"
            id="mce-EMAIL"
            name="EMAIL"
            onChange={(e) => debounceChangeEmail(e.target.value)}
            placeholder="Email address"
            ref={emailRef}
            type="text"
          />
        </div>
        <div>Please select all the ways you would like to hear from :</div>
        <div className="flex items-center gap-2">
          <Checkbox
            checked={checked}
            className="border-text500 data-[state=checked]:bg-green800 data-[state=checked]:border-green800 h-6 w-6 rounded-md data-[state=checked]:text-white"
            id="gdpr_32345"
            name="gdpr[32345]"
            onCheckedChange={(v) => {
              setChecked(Boolean(v));
            }}
          />
          <label className="text-text300" htmlFor="gdpr_32345">
            Email
          </label>
        </div>
        <button
          className="bg-back300 border-blue700 disabled:border-text700 text-blue700 disabled:text-text700 rounded-md border px-5 py-[14px] text-center text-sm font-medium"
          disabled={submitDisabled}
          type="submit"
        >
          SUBSCRIBE
        </button>
        <div>
          For information about our privacy practices, please see our{' '}
          <a
            className="text-blue700"
            href="https://scopely.com/privacy/"
            rel="noopener noreferrer"
            target="_blank"
          >
            Privacy Policy
          </a>{' '}
          and our terms of service. We use Mailchimp as our marketing platform.
          By clicking below to subscribe, you acknowledge that your information
          will be transferred to Mailchimp for processing.{' '}
          <a
            className="text-blue700"
            href="https://scopely.com/tos/"
            rel="noopener noreferrer"
            target="_blank"
          >
            Terms of Service
          </a>
        </div>
      </div>
    </form>
  );
};
